<template>
  <div id="pageCargo">
    <v-container grid-list-x2 fluid>
      <v-layout row wrap justify-center>
        <v-flex lg8 sm12 xs12>
          <cargo-table></cargo-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import CargoTable from "@/components/cargo/tableCargo"
export default {
  components: {
    CargoTable
  }
}
</script>
